import { FC } from 'react';
import compose from 'ia-react-core/~/utils/components/_compose';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow from 'ia-react-core/~/hocs/withShow';
import PostalCodeControl, { PostalCodeControlProps, PostalCodeControlStatics } from './PostalCodeControl';
import withFormState from '../../../hocs/form/_withFormState';

import withPostalCodeControl from './withPostalCodeControl';

export * from './PostalCodeControl';

export default compose<FC<WithBehaviorsProps<PostalCodeControlProps>> & PostalCodeControlStatics>(
  withBehaviors,
  withShow,
  withFormState,
  withPostalCodeControl,
)(PostalCodeControl);
